module.exports = __webpack_public_path__ + "static/media/2.423a5f09.jpg";